<form
  [formGroup]="form"
  class="row"
>
  <div class="col-12 col-lg-6">
    <h4 *ngIf="!isSowJobType">Salary range annually</h4>
    <div class="row">
      <div class="col-4">
        <mojo-currency-dropdown
          [parentForm]="form"
          controlName="salaryCurrency"
        >
        </mojo-currency-dropdown>
      </div>
      <mat-form-field
        color="accent"
        class="col-4 pl-0"
      >
        <mat-label>Min</mat-label>
        <input
          matInput
          id="minSalary"
          formControlName="minSalary"
          placeholder="Min"
          mask="coma_separator"
          data-cy="basic-job-min-salary-input"
        >
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="col-4 pl-0"
      >
        <mat-label>Max</mat-label>
        <input
          matInput
          id="maxSalary"
          formControlName="maxSalary"
          placeholder="Max"
          mask="coma_separator"
          data-cy="basic-job-max-salary-input"
        >
      </mat-form-field>
    </div>
  </div>
  <div
    *ngIf="!isSowJobType"
    class="col-12 col-lg-6"
  >
    <h4>Bonus annually</h4>
    <div class="row">
      <div class="col-4">
        <mojo-currency-dropdown
          [parentForm]="form"
          controlName="bonusCurrency"
        >
        </mojo-currency-dropdown>
      </div>
      <mat-form-field
        class="col-8 pl-0"
        color="accent"
      >
        <mat-label>Amount</mat-label>
        <input
          matInput
          type="text"
          id="bonus"
          placeholder="Amount"
          formControlName="bonus"
          mask="coma_separator"
          data-cy="basic-job-bonus-salary-input"
        />
      </mat-form-field>
    </div>
  </div>
</form>
